import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'lin-form-file-row',
  template: `
    <div class="file-row">
      <mat-icon svgIcon="attach_file" class="file-icon"></mat-icon>
      @if (!url) {
        {{ name }}
      }
      @if (url) {
        <a [href]="url" target="_blank">{{ name }}</a>
      }
      @if (!disabled) {
        <button type="button" mat-icon-button (click)="delete.emit()">
          <mat-icon svgIcon="delete_outline"></mat-icon>
        </button>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }

      .file-icon {
        cursor: default;
      }

      .file-row {
        display: flex;
        align-items: center;
        font-size: 1.25em;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FileRowComponent {
  @Input() name: string
  @Input() url: string
  @Input() disabled = false
  @Output() delete = new EventEmitter<void>()
}
